import req from "../http";

// 人事資料表
const personnelInformation = {
  // 下載 IDL 人事資料 PDF
  downloadIDLPersonnelInformationPDF(matchId) {
    return req("get", `/Recruitment/PersonnelInformation/DownloadPDF/IDL/${matchId}`,  null, { responseType: "blob" });
  },

  // 下載 DL 人事資料 PDF
  downloadDLPersonnelInformationPDF(matchId) {
    return req("get", `/Recruitment/PersonnelInformation/DownloadPDF/DL/${matchId}`, null, { responseType: "blob" });
  }
};

export default personnelInformation;